import React, { useEffect } from "react";
import { connect } from "react-redux";
import PageTitle from '../../Component/Comman/PageTitle';
import ReferInfo from "../../Component/ReferPage/ReferInfo";
import { fetchReferrals } from "../../Redux/Actions/dataActions";

function ReferalPage({ referrals, user, fetchReferrals, loading }) {
    useEffect(() => {
        if (!referrals && !loading) {
            fetchReferrals();
        }
    }, [referrals, fetchReferrals, loading]);

    return (
        <>
            <div className="body-header border-bottom d-flex py-3 mb-3">
                <PageTitle pagetitle='Referrals' sidebutton={true} />
            </div>
            <div className="container-xxl">
                <ReferInfo referrals={referrals} user={user} loading={loading} />
            </div>
        </>
    )
}

const mapStateToProps = (state) => ({
    referrals: state.data?.referrals,
    user: state.auth?.user,
    loading: state.data?.loading?.referrals || false,
});

export default connect(mapStateToProps, { fetchReferrals })(ReferalPage);